import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pt_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Notify the app to refresh the credit counter after any generation call.
api.interceptors.response.use((response) => {
  const method = (response.config?.method || "").toLowerCase();
  const url = response.config?.url || "";
  if (method === "post" && !/\/(auth|usage|assistant|site|leads|inspiration|billing)/.test(url)) {
    window.dispatchEvent(new Event("usage-changed"));
  }
  return response;
});

export function apiError(err, fallback = "Noget gik galt. Prøv igen.") {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || fallback;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}

export default api;
